<template>
    <div>
      <trademark-list></trademark-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  